__turbopack_context__.v({
  "widget": "_45Bu6G_widget",
  "wrapper": "_45Bu6G_wrapper",
});
